import React from 'react'
import { AppState } from '@halo/stores/app.state'
import { Modal, notification } from 'antd'
import { patchWhiteLabel, destroyWhiteLabel } from '@halo/api/white-labels.api'
import { ModalFuncProps } from 'antd/lib/modal'
import WhiteLabelModel from '@halo/models/white-label.model'

const DEFAULT_ACTION_MODAL_PROPS: Partial<ModalFuncProps> = {
    okText: 'Continue',
    okButtonProps: {
        className: 'white-label-confirmation-modal-ok-btn',
        size: 'small',
    },
    cancelButtonProps: {
        className: 'white-label-confirmation-modal-cancel-btn',
        size: 'small',
    },
}

const defaultFailureHandler = (res: any) => {
    notification.error({
        message: '',
        description: 'We were unable to update the white-label at this time. See console for more details.',
    })

    console.warn(res)
    return false
}

export const handleWhiteLabelDisable = (whiteLabel: WhiteLabelModel, onComplete: (ok: boolean, job: any) => void) => {
    Modal.confirm({
        ...DEFAULT_ACTION_MODAL_PROPS,
        title: 'Disable White-Label',
        content: (
            <>
                <p>Are you sure you want to disable the following white-label?</p>
                <p>
                    <b>Display Name:</b> {whiteLabel.getDisplayName()}
                    <br />
                    <b>Hostname:</b> {whiteLabel.getHostname()}
                    <br />
                </p>
            </>
        ),
        onOk: async (...args: any[]) => {
            const res = await patchWhiteLabel(whiteLabel.getId(), { isActive: false })

            if (res.ok) {
                notification.success({
                    message: '',
                    description: 'White-Label successfully disabled.',
                })

                return onComplete(res.ok, res.data)
            } else {
                return defaultFailureHandler(res)
            }
        },
        onCancel: () => onComplete(false, null),
    })
}

export const handleWhiteLabelEnable = async (
    whiteLabel: WhiteLabelModel,
    onComplete: (ok: boolean, job: any) => void,
) => {
    const res = await patchWhiteLabel(whiteLabel.getId(), { isActive: true })

    if (res.ok) {
        notification.success({
            message: '',
            description: 'White-Label successfully enabled.',
        })

        return onComplete(res.ok, res.data)
    } else {
        return defaultFailureHandler(res)
    }
}

export const handleWhiteLabelDestroy = (whiteLabel: WhiteLabelModel, onComplete: (ok: boolean, job: any) => void) => {
    Modal.confirm({
        ...DEFAULT_ACTION_MODAL_PROPS,
        title: 'Delete WhiteLabel',
        content: (
            <>
                <p>Are you sure you want to (soft) delete the following white-label?</p>
                <p>
                    <b>Display Name:</b> {whiteLabel.getDisplayName()}
                    <br />
                    <b>Hostname:</b> {whiteLabel.getHostname()}
                    <br />
                </p>
            </>
        ),
        onOk: async (...args: any[]) => {
            const res = await destroyWhiteLabel(whiteLabel.getId())

            if (res.ok) {
                notification.success({
                    message: '',
                    description: 'White-Label successfully deleted.',
                })

                return onComplete(res.ok, res.data)
            } else {
                return defaultFailureHandler(res)
            }
        },
        onCancel: () => onComplete(false, null),
    })
}
